import React from 'react';
import PropTypes from 'prop-types';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

function FormError({ styles: customStyles, children }) {
  return (
    <Text tag="p" styles={[styles.formError, ...customStyles]}>
      {children}
    </Text>
  );
}

FormError.propTypes = {
  styles: PropTypes.array,
  children: PropTypes.any
};

FormError.defaultProps = {
  styles: [],
  children: null
};

export default FormError;
